[
  {
    "code": "MK-801",
    "name": "Aerodrom"
  },
  {
    "code": "MK-802",
    "name": "Aračinovo"
  },
  {
    "code": "MK-201",
    "name": "Berovo"
  },
  {
    "code": "MK-501",
    "name": "Bitola"
  },
  {
    "code": "MK-401",
    "name": "Bogdanci"
  },
  {
    "code": "MK-601",
    "name": "Bogovinje"
  },
  {
    "code": "MK-402",
    "name": "Bosilovo"
  },
  {
    "code": "MK-602",
    "name": "Brvenica"
  },
  {
    "code": "MK-803",
    "name": "Butel"
  },
  {
    "code": "MK-814",
    "name": "Centar"
  },
  {
    "code": "MK-313",
    "name": "Centar Župa"
  },
  {
    "code": "MK-303",
    "name": "Debar"
  },
  {
    "code": "MK-304",
    "name": "Debarca"
  },
  {
    "code": "MK-203",
    "name": "Delčevo"
  },
  {
    "code": "MK-502",
    "name": "Demir Hisar"
  },
  {
    "code": "MK-103",
    "name": "Demir Kapija"
  },
  {
    "code": "MK-406",
    "name": "Dojran"
  },
  {
    "code": "MK-503",
    "name": "Dolneni"
  },
  {
    "code": "MK-804",
    "name": "Gazi Baba"
  },
  {
    "code": "MK-405",
    "name": "Gevgelija"
  },
  {
    "code": "MK-805",
    "name": "Gjorče Petrov"
  },
  {
    "code": "MK-604",
    "name": "Gostivar"
  },
  {
    "code": "MK-102",
    "name": "Gradsko"
  },
  {
    "code": "MK-807",
    "name": "Ilinden"
  },
  {
    "code": "MK-606",
    "name": "Jegunovce"
  },
  {
    "code": "MK-205",
    "name": "Karbinci"
  },
  {
    "code": "MK-808",
    "name": "Karpoš"
  },
  {
    "code": "MK-104",
    "name": "Kavadarci"
  },
  {
    "code": "MK-809",
    "name": "Kisela Voda"
  },
  {
    "code": "MK-307",
    "name": "Kičevo"
  },
  {
    "code": "MK-407",
    "name": "Konče"
  },
  {
    "code": "MK-206",
    "name": "Kočani"
  },
  {
    "code": "MK-701",
    "name": "Kratovo"
  },
  {
    "code": "MK-702",
    "name": "Kriva Palanka"
  },
  {
    "code": "MK-504",
    "name": "Krivogaštani"
  },
  {
    "code": "MK-505",
    "name": "Kruševo"
  },
  {
    "code": "MK-703",
    "name": "Kumanovo"
  },
  {
    "code": "MK-704",
    "name": "Lipkovo"
  },
  {
    "code": "MK-105",
    "name": "Lozovo"
  },
  {
    "code": "MK-207",
    "name": "Makedonska Kamenica"
  },
  {
    "code": "MK-308",
    "name": "Makedonski Brod"
  },
  {
    "code": "MK-607",
    "name": "Mavrovo i Rostuše"
  },
  {
    "code": "MK-506",
    "name": "Mogila"
  },
  {
    "code": "MK-106",
    "name": "Negotino"
  },
  {
    "code": "MK-507",
    "name": "Novaci"
  },
  {
    "code": "MK-408",
    "name": "Novo Selo"
  },
  {
    "code": "MK-310",
    "name": "Ohrid"
  },
  {
    "code": "MK-208",
    "name": "Pehčevo"
  },
  {
    "code": "MK-810",
    "name": "Petrovec"
  },
  {
    "code": "MK-311",
    "name": "Plasnica"
  },
  {
    "code": "MK-508",
    "name": "Prilep"
  },
  {
    "code": "MK-209",
    "name": "Probištip"
  },
  {
    "code": "MK-409",
    "name": "Radoviš"
  },
  {
    "code": "MK-705",
    "name": "Rankovce"
  },
  {
    "code": "MK-509",
    "name": "Resen"
  },
  {
    "code": "MK-107",
    "name": "Rosoman"
  },
  {
    "code": "MK-811",
    "name": "Saraj"
  },
  {
    "code": "MK-812",
    "name": "Sopište"
  },
  {
    "code": "MK-706",
    "name": "Staro Nagoričane"
  },
  {
    "code": "MK-312",
    "name": "Struga"
  },
  {
    "code": "MK-410",
    "name": "Strumica"
  },
  {
    "code": "MK-813",
    "name": "Studeničani"
  },
  {
    "code": "MK-108",
    "name": "Sveti Nikole"
  },
  {
    "code": "MK-608",
    "name": "Tearce"
  },
  {
    "code": "MK-609",
    "name": "Tetovo"
  },
  {
    "code": "MK-403",
    "name": "Valandovo"
  },
  {
    "code": "MK-404",
    "name": "Vasilevo"
  },
  {
    "code": "MK-101",
    "name": "Veles"
  },
  {
    "code": "MK-301",
    "name": "Vevčani"
  },
  {
    "code": "MK-202",
    "name": "Vinica"
  },
  {
    "code": "MK-603",
    "name": "Vrapčište"
  },
  {
    "code": "MK-806",
    "name": "Zelenikovo"
  },
  {
    "code": "MK-204",
    "name": "Zrnovci"
  },
  {
    "code": "MK-815",
    "name": "Čair"
  },
  {
    "code": "MK-109",
    "name": "Čaška"
  },
  {
    "code": "MK-210",
    "name": "Češinovo-Obleševo"
  },
  {
    "code": "MK-816",
    "name": "Čučer-Sandevo"
  },
  {
    "code": "MK-211",
    "name": "Štip"
  },
  {
    "code": "MK-817",
    "name": "Šuto Orizari"
  },
  {
    "code": "MK-605",
    "name": "Želino"
  }
]